import React from 'react';
import { ProductsShowcaseSection } from '../shared/ProductsShowcaseSection';
import { MegaphoneIcon } from 'lucide-react';
export function EndingSoonDeals() {
  const products = [{
    id: 1,
    name: 'Sunshine Nutrition Vitamin C',
    brand: 'Sunshine Nutrition',
    price: 10.75,
    originalPrice: 27.0,
    discount: 60,
    rating: 4.6,
    reviewCount: 1325,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Similac Gold 3 Milk Formula',
    brand: 'Similac',
    price: 58.0,
    originalPrice: 76.7,
    discount: 24,
    rating: 4.7,
    reviewCount: 56,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Bioderma Sensibio H2O',
    brand: 'Bioderma',
    price: 39.95,
    originalPrice: 124.0,
    discount: 68,
    rating: 4.8,
    reviewCount: 119,
    image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Cosrx Advanced Snail 96 Mucin',
    brand: 'Cosrx',
    price: 28.1,
    originalPrice: 105.0,
    discount: 73,
    rating: 4.9,
    reviewCount: 133,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Nizoral Anti Dandruff Shampoo',
    brand: 'Nizoral',
    price: 19.0,
    originalPrice: 57.75,
    discount: 67,
    rating: 4.5,
    reviewCount: 1123,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'La Roche Posay Anthelios Sunscreen',
    brand: 'La Roche Posay',
    price: 53.0,
    originalPrice: 140.95,
    discount: 62,
    rating: 4.7,
    reviewCount: 420,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }];
  return <div className="container mx-auto px-4" data-id="element-4387" data-mp="3j3uvcbsq5peh">
      <ProductsShowcaseSection title="ENDING SOON" subtitle="LAST CHANCE" backgroundColor="bg-gradient-to-r from-pink-500 to-rose-500" products={products} icon={<MegaphoneIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-4389" data-mp="3s1f2209cwdwh" />} viewAllLink="#ending-soon" data-id="element-4388" data-mp="3j4o6doypv12f" />
    </div>;
}